import { render, staticRenderFns } from "./refuseUserList.vue?vue&type=template&id=63d3409c"
import script from "./refuseUserList.vue?vue&type=script&lang=js"
export * from "./refuseUserList.vue?vue&type=script&lang=js"
import style0 from "./refuseUserList.vue?vue&type=style&index=0&id=63d3409c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports